import IAction from "../store/IAction";
import IApplicationVm from "../models/shared/IApplicationVm";
import InitState from "../store/initState";
import { Dispatch } from "redux";
import IIdentityProviderRealmVm from "../models/home/Shared/IIdentityProviderRealmVm";
import { IToastrMessage } from "../containers/Shared/ToastrContainer";
import { CertificateType } from "../models/flags/CertificateType";
import { push } from "connected-react-router";
import { UserType } from "../models/flags/UserType";
import * as applicationsReducer from "./applicationsReducer";
import { ApplicationStatusType } from "../models/enums/ApplicationStatusType";
import IPhotoCropVm from "../models/home/PhotoCrop/IPhotoCropVm";
import { ApplicationSubmitStatusType } from "../models/enums/ApplicationSubmitStatusType";
import { IApplicationSearchObject } from "../components/SearchApplications/SearchBox";
import ITeamVm from "../models/shared/ITeamVm";
import * as ITeamVmInstance from "../models/shared/ITeamVm";
import { ErrorCaseType } from "../models/enums/ErrorCaseType";
import { ErrorCaseStatusType } from "../models/enums/ErrorCaseStatusType";
import { InvoiceStatusType } from "../models/enums/InvoiceStatusType";
import IParentBulkInvoiceVm from "../models/home/Payment/IParentBulkInvoiceVm";
import { Guid } from "guid-typescript";
import IErrorVm from "../models/home/Error/IErrorVm";
import { SelectedPayorType } from "../pages/payment/Payment";
import { BulkPaymentDateSearchType } from "../models/enums/BulkPaymentDateSearchType";
import { CertificateProcessType } from "../models/flags/CertificateProcessType";
import UserHelper from "../services/userHelper";
import { ApplicationEventType } from "../models/enums/ApplicationEventType";

const ADD_TOASTR = "BAT2/meta/ADD_TOASTR";
const ADD_TOASTR_COLLECTION = "BAT2/meta/ADD_TOASTR_COLLECTION";
const REMOVE_TOASTR = "BAT2/meta/REMOVE_TOASTR";
const REPLACE_APPLICATIONS_FOR_BULK_PAYMENTS = "BAT2/meta/REPLACE_APPLICATIONS_FOR_BULK_PAYMENTS";
const REPLACE_BULK_INVOICE = "BAT2/meta/REPLACE_BULK_INVOICE";
const REPLACE_BULK_INVOICES = "BAT2/meta/REPLACE_BULK_INVOICES";
const RESET_APPLICATION_SEARCH_OBJECT = "BAT2/meta/RESET_APPLICATION_SEARCH_OBJECT";
const RESET_BULK_INVOICE_SEARCH_OBJECT = "BAT2/meta/RESET_BULK_INVOICE_SEARCH_OBJECT";
const RESET_ERROR_CASE_SEARCH_OBJECT = "BAT2/meta/RESET_ERROR_CASE_SEARCH_OBJECT";
const SELECT_REALM = "BAT2/meta/SELECT_REALM";
const SET_DISABLE_SPINNER = "BAT2/meta/SET_DISABLE_SPINNER";
const SET_SELECTED_ERROR_CASE_ID = "BAT2/meta/SET_SELECTED_ERROR_CASE_ID";
const UPDATE_APPLCIATION_SEARCH_OBJECT = "BAT2/meta/UPDATE_APPLCIATION_SEARCH_OBJECT";
const UPDATE_APPLICATION_SEARCH_LIST_PAGE_NUMBER = "BAT2/meta/UPDATE_APPLICATION_SEARCH_LIST_PAGE_NUMBER";
const UPDATE_APPLICATION_SEARCH_LIST_SORT_PROPERTY = "BAT2/meta/UPDATE_APPLICATION_SEARCH_LIST_SORT_PROPERTY";
const UPDATE_APPLICATION_SEARCH_LIST_TOTAL_ROWS_COUNT = "BAT2/meta/UPDATE_APPLICATION_SEARCH_LIST_TOTAL_ROWS_COUNT";
const UPDATE_APPLICATIONS_FOR_BULK_PAYMENTS_SEARCH_TOTAL_ROWS_COUNT = "BAT2/meta/UPDATE_APPLICATIONS_FOR_BULK_PAYMENTS_SEARCH_TOTAL_ROWS_COUNT";
const UPDATE_BULK_INVOICE_LIST_PAGE_NUMBER = "BAT2/meta/UPDATE_BULK_INVOICE_LIST_PAGE_NUMBER";
const UPDATE_BULK_INVOICE_SEARCH_OBJECT = "BAT2/meta/UPDATE_BULK_INVOICE_SEARCH_OBJECT";
const UPDATE_BULK_INVOICE_SEARCH_TOTAL_ROWS_COUNT = "BAT2/meta/UPDATE_BULK_INVOICE_SEARCH_TOTAL_ROWS_COUNT";
const UPDATE_ERROR_CASE_LIST_PAGE = "BAT2/meta/UPDATE_ERROR_CASE_LIST_PAGE";
const UPDATE_ERROR_CASE_LIST_SORT = "BAT2/meta/UPDATE_ERROR_CASE_LIST_SORT";
const UPDATE_ERROR_CASE_SEARCH_OBJECT = "BAT2/meta/UPDATE_ERROR_CASE_SEARCH_OBJECT";
const UPDATE_ERROR_CASE_SEARCH_TOTAL_ROWS_COUNT = "BAT2/meta/UPDATE_ERROR_CASE_SEARCH_TOTAL_ROWS_COUNT";
const UPDATE_IS_CREATE_NEW_PAYOR_COMPONENT_MODAL_OPEN = "BAT2/meta/UPDATE_IS_CREATE_NEW_PAYOR_COMPONENT_MODAL_OPEN";
const UPDATE_PROFILE_IMAGE_CROP = "BAT2/meta/UPDATE_PROFILE_IMAGE_CROP";
const UPDATE_SELECTED_PAYOR = "BAT2/meta/UPDATE_SELECTED_PAYOR";
const UPDATE_TEMPORARY_PROFILE_IMAGE = "BAT2/meta/UPDATE_TEMPORARY_PROFILE_IMAGE";
export const SET_ASYNC_RUNNING = "BAT2/meta/SET_ASYNC_RUNNING";
export const SET_SELECTED_APPLICATION = "BAT2/meta/SET_SELECTED_APPLICATION";
export const SET_SELECTED_PRISTINE = "BAT2/meta/SET_SELECTED_PRISTINE";
export const SET_SELECTED_TEAM = "BAT2/meta/SET_SELECTED_TEAM";
export const UPDATE_SELECTED_TEAM_NAME = "BAT2/meta/UPDATE_SELECTED_TEAM_NAME";
export const UPDATE_VALIDATION = "BAT2/meta/UPDATE_VALIDATION";

const defaultApplicationSearchObject: IApplicationSearchObject = {
  educationalInstitutionId: "",
  invoiceNumber: "",
  civilRegistrationIdentifier: "",
  certificateNumber: "",
  certificateType: CertificateType.NotSet,
  certificateProcessType: CertificateProcessType.NotSet,
  name: "",
  applicationStatus: ApplicationStatusType.Pending,
  isApplicationSubmittetByEducationalInstitution: ApplicationSubmitStatusType.NotSet,
  isApplicationSubmittetByCitizen: ApplicationSubmitStatusType.NotSet,
  teamId: "",
  companyId: "",
  applicationEventType: ApplicationEventType.NotSet,
  applicationEventTypeDateFrom: "",
  applicationEventTypeDateTo: "",
};

const defaultErrorCaseSearchObject: IErrorCaseSearchObject = {
  errorCaseNumber: "",
  certificateType: CertificateType.NotSet,
  applicationCertificateNumber: "",
  errorCaseType: ErrorCaseType.NotSet,
  dateFrom: "",
  dateTo: "",
  errorCaseStatusType: ErrorCaseStatusType.FailedAndPending,
};

const defaultBulkInvoiceSearchObject: IBulkInvoiceSearchObject = {
  companyRegistrationIdentifier: "",
  certificateNumber: "",
  invoiceNumber: "",
  invoiceStatus: InvoiceStatusType.Pending,
  certificateType: CertificateType.NotSet,
  bulkPaymentDateSearchType: BulkPaymentDateSearchType.NotSet,
  dateFrom: "",
  dateTo: "",
};

export default function metaReducer(
  state: IMeta = {
    applicationsForBulkPayments: [],
    applicationsForBulkPaymentsSearchListPageNumber: 1,
    applicationSearchListPageNumber: 1,
    applicationSearchObject: { ...defaultApplicationSearchObject },
    applicationSearchSort: { sortOrderASC: true, sortPropertyName: "certificateNumber" },
    bulkInvoiceSearchListPageNumber: 1,
    bulkInvoiceSearchObject: { ...defaultBulkInvoiceSearchObject },
    bulkInvoiceSearchSort: { sortOrderASC: true, sortPropertyName: "invoiceNumber" },
    bulkInvoices: [],
    errorCaseSearchListPageNumber: 1,
    errorCaseSearchObject: { ...defaultErrorCaseSearchObject },
    errorCaseSearchSort: { sortOrderASC: true, sortPropertyName: "errorNumber" },
    selectedTeam: ITeamVmInstance.empty(),
    isCreateNewPayorComponentModalOpen: false,
  } as IMeta,
  action: IAction
): IMeta {
  switch (action.type) {
    case SET_SELECTED_APPLICATION:
      return { ...state, selectedApplicationId: action.payload };
    case SET_SELECTED_ERROR_CASE_ID:
      return { ...state, selectedErrorCaseId: action.payload };
    case SET_SELECTED_PRISTINE:
      return { ...state, selectedApplicationPristine: action.payload };
    case SELECT_REALM:
      return { ...state, selectedRealm: action.payload };
    case UPDATE_VALIDATION:
      return { ...state, errors: action.payload };
    case UPDATE_SELECTED_PAYOR:
      return { ...state, selectedPayor: action.payload };
    case UPDATE_PROFILE_IMAGE_CROP:
      return { ...state, profileImageCrop: action.payload };
    case REMOVE_TOASTR:
      return { ...state, toastrMessages: state.toastrMessages.filter((tm) => tm !== action.payload) };
    case SET_ASYNC_RUNNING:
      return { ...state, isAsyncRunning: action.payload };
    case SET_DISABLE_SPINNER:
      return { ...state, isSpinnerDisabled: action.payload };
    case ADD_TOASTR:
      return { ...state, toastrMessages: [...(state.toastrMessages ? state.toastrMessages : []), action.payload] };
    case ADD_TOASTR_COLLECTION:
      let messages = [...(state.toastrMessages ? state.toastrMessages : [])];
      messages = messages.concat(action.payload);
      return { ...state, toastrMessages: messages };
    case UPDATE_APPLCIATION_SEARCH_OBJECT:
      return { ...state, applicationSearchObject: action.payload };
    case UPDATE_ERROR_CASE_SEARCH_OBJECT:
      return { ...state, errorCaseSearchObject: action.payload };
    case UPDATE_APPLICATION_SEARCH_LIST_SORT_PROPERTY:
      return { ...state, applicationSearchSort: action.payload };
    case UPDATE_ERROR_CASE_LIST_SORT:
      return { ...state, errorCaseSearchSort: action.payload };
    case UPDATE_APPLICATION_SEARCH_LIST_TOTAL_ROWS_COUNT:
      return { ...state, applicationSearchTotalRowsCount: action.payload };
    case UPDATE_ERROR_CASE_SEARCH_TOTAL_ROWS_COUNT:
      return { ...state, errorCaseSearchTotalRowsCount: action.payload };
    case UPDATE_APPLICATION_SEARCH_LIST_PAGE_NUMBER:
      return { ...state, applicationSearchListPageNumber: action.payload };
    case UPDATE_ERROR_CASE_LIST_PAGE:
      return { ...state, errorCaseSearchListPageNumber: action.payload };
    case RESET_APPLICATION_SEARCH_OBJECT:
      return { ...state, applicationSearchObject: { ...defaultApplicationSearchObject, isApplicationSubmittetByCitizen: ApplicationSubmitStatusType.NotSet, applicationStatus: ApplicationStatusType.NotSet } as IApplicationSearchObject };
    case RESET_ERROR_CASE_SEARCH_OBJECT:
      return { ...state, errorCaseSearchObject: { ...defaultErrorCaseSearchObject, errorCaseStatusType: ErrorCaseStatusType.NotSet } };
    case RESET_BULK_INVOICE_SEARCH_OBJECT:
      return { ...state, bulkInvoiceSearchObject: { ...defaultBulkInvoiceSearchObject, invoiceStatus: InvoiceStatusType.NotSet } };
    case UPDATE_BULK_INVOICE_SEARCH_OBJECT:
      return { ...state, bulkInvoiceSearchObject: action.payload };
    case UPDATE_TEMPORARY_PROFILE_IMAGE:
      return { ...state, temporaryProfileImage: action.payload };
    case SET_SELECTED_TEAM:
      return { ...state, selectedTeam: action.payload };
    case UPDATE_SELECTED_TEAM_NAME:
      const selectedTeamObject = { ...state.selectedTeam, name: action.payload } as ITeamVm;
      return { ...state, selectedTeam: selectedTeamObject };
    case UPDATE_IS_CREATE_NEW_PAYOR_COMPONENT_MODAL_OPEN:
      return { ...state, isCreateNewPayorComponentModalOpen: action.payload };
    case REPLACE_APPLICATIONS_FOR_BULK_PAYMENTS:
      return { ...state, applicationsForBulkPayments: action.payload };
    case REPLACE_BULK_INVOICES:
      return { ...state, bulkInvoices: action.payload };
    case UPDATE_APPLICATIONS_FOR_BULK_PAYMENTS_SEARCH_TOTAL_ROWS_COUNT:
      return { ...state, applicationsForBulkPaymentsTotalRowsCount: action.payload };
    case UPDATE_BULK_INVOICE_SEARCH_TOTAL_ROWS_COUNT:
      return { ...state, bulkInvoiceSearchTotalRowsCount: action.payload };
    case UPDATE_BULK_INVOICE_LIST_PAGE_NUMBER:
      return { ...state, bulkInvoiceSearchListPageNumber: action.payload };
    case REPLACE_BULK_INVOICE:
      return {
        ...state,
        bulkInvoices: [...state.bulkInvoices].map((bulkInvoice) => {
          if (bulkInvoice.id !== (action.payload as IParentBulkInvoiceVm).id) {
            return bulkInvoice;
          }
          return { ...bulkInvoice, ...action.payload };
        }),
      };
    default: {
      return state;
    }
  }
}

export function setAsyncRunning(isRunning: boolean) {
  return { type: SET_ASYNC_RUNNING, payload: isRunning };
}
export function setDisableSpinner(disable: boolean) {
  return { type: SET_DISABLE_SPINNER, payload: disable };
}
export function updateProfileImageCrop(crop: IPhotoCropVm) {
  return { type: UPDATE_PROFILE_IMAGE_CROP, payload: crop };
}

export function setSelectedApplication(application: IApplicationVm) {
  return async (dispatch: Dispatch<any>, getState: () => InitState) => {
    dispatch(applicationsReducer.reloadApplication(application as IApplicationVm));
    if (Guid.isGuid(application.id)) {
      switch (UserHelper.currentUser().type) {
        case UserType.Citizen:
          dispatch(push("/edit_application/" + application.certificateType + "/" + application.certificateProcessType + "/" + application.id + "/0" + "/0"));
          break;
        case UserType.EducationalWorker:
          dispatch(push("/edit_application/" + application.certificateType + "/" + application.certificateProcessType + "/" + application.id));
          break;
        default:
          break;
      }
    }
  };
}
export function updateServerValidation(errors: IErrorVm[]) {
  return async (dispatch: Dispatch<any>, getState: () => InitState) => {
    const messages: IToastrMessage[] = [];
    if (errors.length > 0) {
      errors.forEach((se, i) => {
        messages.push({ message: se.message, type: "error" });
      });
      dispatch(addToastrCollection(messages));
    }
  };
}
export function updateValidation(errors: IErrorVm[]) {
  return { type: UPDATE_VALIDATION, payload: errors };
}
export function updateSelectedRealm(realm: IIdentityProviderRealmVm) {
  return { type: SELECT_REALM, payload: realm };
}
export function removeToastr(toastrMessage: IToastrMessage) {
  return { type: REMOVE_TOASTR, payload: toastrMessage };
}
export function addToastr(toastrMessage: IToastrMessage) {
  return { type: ADD_TOASTR, payload: toastrMessage };
}
export function addToastrCollection(toastrMessages: IToastrMessage[]) {
  return { type: ADD_TOASTR_COLLECTION, payload: toastrMessages };
}
export function replaceBulkInvoice(bulkInvoice: IParentBulkInvoiceVm) {
  return { type: REPLACE_BULK_INVOICE, payload: bulkInvoice };
}
export function updateApplicationSearchObject(applicationSearchObject: IApplicationSearchObject) {
  return { type: UPDATE_APPLCIATION_SEARCH_OBJECT, payload: applicationSearchObject };
}
export function updateErrorCaseSearchObject(errorCaseSearchObject: IErrorCaseSearchObject) {
  return { type: UPDATE_ERROR_CASE_SEARCH_OBJECT, payload: errorCaseSearchObject };
}
export function resetApplicationSearchObject() {
  return { type: RESET_APPLICATION_SEARCH_OBJECT };
}
export function updateApplicationSearchListTotalRowsCount(totalRowsCount: number) {
  return { type: UPDATE_APPLICATION_SEARCH_LIST_TOTAL_ROWS_COUNT, payload: totalRowsCount };
}
export function updateErrorCaseSearchTotalRowsCount(errorCaseSearchTotalRowsCount: number) {
  return { type: UPDATE_ERROR_CASE_SEARCH_TOTAL_ROWS_COUNT, payload: errorCaseSearchTotalRowsCount };
}
export function updateApplicationsForBulkPaymentsSearchTotalRowsCount(applicationsForBulkPaymentsSearchTotalRowsCount: number) {
  return { type: UPDATE_APPLICATIONS_FOR_BULK_PAYMENTS_SEARCH_TOTAL_ROWS_COUNT, payload: applicationsForBulkPaymentsSearchTotalRowsCount };
}
export function updateBulkInvoiceSearchTotalRowsCount(bulkInvoiceSearchTotalRowsCount: number) {
  return { type: UPDATE_BULK_INVOICE_SEARCH_TOTAL_ROWS_COUNT, payload: bulkInvoiceSearchTotalRowsCount };
}
export function updateApplicationSearchListPageNumber(pageNumber: number) {
  return { type: UPDATE_APPLICATION_SEARCH_LIST_PAGE_NUMBER, payload: pageNumber };
}
export function updateErrorCaseListPage(pageNumber: number) {
  return { type: UPDATE_ERROR_CASE_LIST_PAGE, payload: pageNumber };
}
export function updateBulkInvoiceListPageNumber(pageNumber: number) {
  return { type: UPDATE_BULK_INVOICE_LIST_PAGE_NUMBER, payload: pageNumber };
}
export function updateApplicationSearchListSortProperty(sortObject: ISortObject) {
  return { type: UPDATE_APPLICATION_SEARCH_LIST_SORT_PROPERTY, payload: sortObject };
}
export function updateErrorCaseListSort(sortObject: ISortObject) {
  return { type: UPDATE_ERROR_CASE_LIST_SORT, payload: sortObject };
}
export function updateSelectedPayor(payorType: SelectedPayorType) {
  return { type: UPDATE_SELECTED_PAYOR, payload: payorType };
}
export function updateTemporaryProfileImage(base64: string) {
  return { type: UPDATE_TEMPORARY_PROFILE_IMAGE, payload: base64 };
}
export function setSelectedTeam(team: ITeamVm) {
  return { type: SET_SELECTED_TEAM, payload: team };
}
export function updateSelectedTeamName(value: string) {
  return { type: UPDATE_SELECTED_TEAM_NAME, payload: value };
}
export function resetSelectedApplicationId() {
  return { type: SET_SELECTED_APPLICATION, payload: "00000000-0000-0000-0000-000000000000" };
}
export function resetErrorCaseSearchObject() {
  return { type: RESET_ERROR_CASE_SEARCH_OBJECT };
}
export function updateSelectedErrorCaseId(id: string) {
  return { type: SET_SELECTED_ERROR_CASE_ID, payload: id };
}
export function updateIsCreateNewPayorComponentModalOpen(value: boolean) {
  return { type: UPDATE_IS_CREATE_NEW_PAYOR_COMPONENT_MODAL_OPEN, payload: value };
}
export function resetBulkInvoiceSearchObject() {
  return { type: RESET_BULK_INVOICE_SEARCH_OBJECT };
}
export function replaceApplicationsForBulkPayments(value: IApplicationVm[]) {
  return { type: REPLACE_APPLICATIONS_FOR_BULK_PAYMENTS, payload: value };
}
export function replaceBulkInvoices(value: IParentBulkInvoiceVm[]) {
  return { type: REPLACE_BULK_INVOICES, payload: value };
}
export function updateBulkInvoiceSearchObject(value: IBulkInvoiceSearchObject) {
  return { type: UPDATE_BULK_INVOICE_SEARCH_OBJECT, payload: value };
}
export interface IMeta {
  applicationsForBulkPayments: IApplicationVm[];
  applicationsForBulkPaymentsTotalRowsCount: number;
  applicationsForBulkPaymentsSearchListPageNumber: number;
  applicationSearchListPageNumber: number;
  applicationSearchObject: IApplicationSearchObject;
  applicationSearchSort: ISortObject;
  applicationSearchTotalRowsCount: number;
  bulkInvoiceSearchListPageNumber: number;
  bulkInvoiceSearchObject: IBulkInvoiceSearchObject;
  bulkInvoiceSearchTotalRowsCount: number;
  bulkInvoiceSearchSort: ISortObject;
  bulkInvoices: IParentBulkInvoiceVm[];
  currentStepId: number;
  errorCaseSearchListPageNumber: number;
  errorCaseSearchObject: IErrorCaseSearchObject;
  errorCaseSearchSort: ISortObject;
  errorCaseSearchTotalRowsCount: number;
  errors: IErrorVm[];
  isAsyncRunning: boolean;
  isReceiptModalShown: boolean;
  isSpinnerDisabled: boolean;
  profileImageCrop: IPhotoCropVm;
  selectedApplicationPristine: IApplicationVm;
  selectedApplicationId: string;
  selectedErrorCaseId: string;
  selectedPayor: SelectedPayorType;
  selectedRealm: IIdentityProviderRealmVm;
  selectedTeam: ITeamVm;
  temporaryProfileImage: string;
  toastrMessages: IToastrMessage[];
  isCreateNewPayorComponentModalOpen: boolean;
}

export interface IBulkInvoiceSearchObject {
  companyRegistrationIdentifier: string;
  certificateNumber: string;
  invoiceNumber: string;
  invoiceStatus: InvoiceStatusType;
  certificateType: CertificateType;
  bulkPaymentDateSearchType: BulkPaymentDateSearchType;
  dateFrom: string;
  dateTo: string;
}

export interface IErrorCaseSearchObject {
  errorCaseNumber: string;
  certificateType: CertificateType;
  applicationCertificateNumber: string;
  errorCaseType: ErrorCaseType;
  dateFrom: string;
  dateTo: string;
  errorCaseStatusType: ErrorCaseStatusType;
}

export interface ISortObject {
  sortPropertyName: string;
  sortOrderASC: boolean;
}
